export default {
  updateWindowActive (state, val) {
    state.windowActive = val;
  },

  updateWallActive (state, val) {
    state.wallActive = val;
  },

  updateInteriors(state, data) {
    state.interiors = data;
  },

  updateInteriorActive(state, val) {
    state.interiorActive = val;
  },

  updateWindows(state, data) {
    state.windows = data;
  },
}
